import { render, staticRenderFns } from "./ActionConfirmationModal.vue?vue&type=template&id=22047270&"
import script from "./ActionConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ActionConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports